import ActionButtons from '@flows/src/components/flows-configure/shared/ActionButtons';
import AssistantQuestion from '@sales-conversation/src/components/flow/AssistantQuestion';
import ScrollableContentContainer from '@sales-conversation/src/components/layout/ScrollableContentContainer';
import { Grid, Text, VStack } from '@wegroup/design-system';
import { FC, PropsWithChildren } from 'react';

interface Props {
  question: string;
  onNext?: () => void;
  onPrevious?: () => void;
  error?: string;
}

const ContentWrapper: FC<PropsWithChildren<Props>> = ({
  question,
  onNext,
  onPrevious,
  children,
  error,
}) => {
  return (
    <Grid height="100%" width="100%" templateRows="minmax(1px, 1fr) auto">
      <ScrollableContentContainer>
        <AssistantQuestion question={question} />
        <VStack align="stretch" w="100%" maxW="3xl" alignSelf="center" h="100%">
          {children}
        </VStack>
      </ScrollableContentContainer>
      {error && (
        <Text color="danger.main" mb="8" align="center">
          {error}
        </Text>
      )}
      <ActionButtons onBack={onPrevious} onContinue={() => onNext?.()} />
    </Grid>
  );
};

export default ContentWrapper;
